class Wishlist {
  constructor() {
    this.storageKey = 'biggles_wishlist';
    this.wishlist = this.getWishlist();
    
    // Clear old wishlist data if it doesn't have the correct structure
    if (this.wishlist.length > 0 && !this.wishlist[0].hasOwnProperty('variant_id')) {
      console.log('Clearing old wishlist data format');
      this.clearWishlist();
    }
    
    // Check if theme routes are available
    if (window.theme && window.theme.routes) {
      console.log('Theme routes available:', window.theme.routes);
    } else {
      console.warn('Theme routes not available, using fallback cart URLs');
    }
    
    this.init();
  }

  init() {
    this.bindEvents();
    this.updateWishlistCount();
    
    // Update wishlist buttons with a small delay to ensure DOM is ready
    setTimeout(() => {
      this.updateWishlistButtons();
    }, 100);
  }

  getWishlist() {
    try {
      const stored = localStorage.getItem(this.storageKey);
      return stored ? JSON.parse(stored) : [];
    } catch (error) {
      console.error('Error reading wishlist from localStorage:', error);
      return [];
    }
  }

  saveWishlist() {
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(this.wishlist));
      this.updateWishlistCount();
    } catch (error) {
      console.error('Error saving wishlist to localStorage:', error);
    }
  }

  addToWishlist(product) {
    console.log('Adding to wishlist:', product);
    const existingIndex = this.wishlist.findIndex(item => item.id === product.id);
    
    if (existingIndex === -1) {
      this.wishlist.push(product);
      this.saveWishlist();
      this.updateWishlistPadding();
      console.log('Wishlist after adding:', this.wishlist);
      return true;
    } else {
      console.log('Product already in wishlist');
      return false;
    }
  }

  removeFromWishlist(productId) {
    const index = this.wishlist.findIndex(item => item.id === productId);
    
    if (index !== -1) {
      this.wishlist.splice(index, 1);
      this.saveWishlist();
      this.updateWishlistPadding();
      return true;
    }
    return false;
  }

  isInWishlist(productId) {
    return this.wishlist.some(item => item.id === productId);
  }

  updateWishlistPadding() {
    const container = document.querySelector('.wishlist-content');
    if (!container) return;

    // Add or remove wishlist-no-padding class based on item count
    if (this.wishlist.length < 4 && this.wishlist.length > 0) {
      container.classList.add('wishlist-no-padding');
    } else {
      container.classList.remove('wishlist-no-padding');
    }
  }

  getWishlistItems() {
    return this.wishlist;
  }

  getWishlistCount() {
    return this.wishlist.length;
  }

  clearWishlist() {
    this.wishlist = [];
    this.saveWishlist();
    this.updateWishlistPadding();
  }

  updateWishlistCount() {
    const count = this.getWishlistCount();
    const countElements = document.querySelectorAll('[data-wishlist-count]');
    
    countElements.forEach(element => {
      element.textContent = count;
      element.style.display = count > 0 ? 'inline' : 'none';
    });
  }

  updateWishlistButtons() {
    const buttons = document.querySelectorAll('[data-wishlist-button]');
    
    buttons.forEach(button => {
      const productId = parseInt(button.dataset.productId);
      const isInWishlist = this.isInWishlist(productId);
      
      // Update button state
      button.classList.toggle('wishlist-button--active', isInWishlist);
      
      // Update wishlist container visibility
      const wishlistContainer = button.closest('.product-grid-item__wishlist');
      if (wishlistContainer) {
        wishlistContainer.classList.toggle('wishlist-container--active', isInWishlist);
      }
      
      // Update icon
      const iconOutline = button.querySelector('.wishlist-button__icon--outline');
      const iconFilled = button.querySelector('.wishlist-button__icon--filled');
      
      if (iconOutline && iconFilled) {
        iconOutline.style.display = isInWishlist ? 'none' : 'inline';
        iconFilled.style.display = isInWishlist ? 'inline' : 'none';
      }
      
      // Update aria-label
      button.setAttribute('aria-label', isInWishlist ? 'Remove from wishlist' : 'Add to wishlist');
    });
  }

  bindEvents() {
    // Bind wishlist button clicks
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-wishlist-button]')) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        const button = e.target.closest('[data-wishlist-button]');
        const productId = parseInt(button.dataset.productId);
        
        console.log('Wishlist button clicked:', { productId, button });
        
        if (this.isInWishlist(productId)) {
          console.log('Removing product', productId, 'from wishlist');
          this.removeFromWishlist(productId);
          this.renderWishlist();
          this.updateWishlistButtons();
        } else {
          const productData = {
            id: productId,
            variant_id: parseInt(button.dataset.variantId),
            handle: button.dataset.productHandle,
            title: button.dataset.productTitle,
            image: button.dataset.productImage,
            price: button.dataset.productPrice,
            compare_at_price: button.dataset.productComparePrice,
            url: button.dataset.productUrl,
            available: button.dataset.productAvailable === 'true',
            tags: button.dataset.productTags ? button.dataset.productTags.split(',').map(t => t.trim()) : [] 
          };
          this.addToWishlist(productData);
        }
        
        this.updateWishlistButtons();
      }
    });

    // Bind touch events for mobile carousel wishlist buttons
    document.addEventListener('touchend', (e) => {
      if (e.target.closest('[data-wishlist-button]')) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        const button = e.target.closest('[data-wishlist-button]');
        const productId = parseInt(button.dataset.productId);
        
        console.log('Wishlist button touched:', { productId, button });
        
        if (this.isInWishlist(productId)) {
          console.log('Removing product', productId, 'from wishlist');
          this.removeFromWishlist(productId);
          this.renderWishlist();
          this.updateWishlistButtons();
        } else {
          const productData = {
            id: productId,
            variant_id: parseInt(button.dataset.variantId),
            handle: button.dataset.productHandle,
            title: button.dataset.productTitle,
            image: button.dataset.productImage,
            price: button.dataset.productPrice,
            compare_at_price: button.dataset.productComparePrice,
            url: button.dataset.productUrl,
            available: button.dataset.productAvailable === 'true',
            tags: button.dataset.productTags ? button.dataset.productTags.split(',').map(t => t.trim()) : [] 
          };
          this.addToWishlist(productData);
        }
        
        this.updateWishlistButtons();
      }
    });

    // Bind add to cart buttons in wishlist
    document.addEventListener('click', (e) => {
      if (e.target.closest('.wishlist-add-to-cart')) {
        const button = e.target.closest('.wishlist-add-to-cart');
        const productId = parseInt(button.dataset.productId);
        const variantId = parseInt(button.dataset.variantId);
        
        console.log('Add to cart clicked:', { productId, variantId, button });
        console.log('Button dataset:', button.dataset);
        
        this.addProductToCart(variantId, button);
      }
    });

    // Bind remove from wishlist buttons
    document.addEventListener('click', (e) => {
      if (e.target.closest('.wishlist-remove')) {
        const button = e.target.closest('.wishlist-remove');
        const productId = parseInt(button.dataset.productId);
        
        this.removeFromWishlist(productId);
        this.renderWishlist();
        this.updateWishlistButtons();
      }
    });

    // Bind clear wishlist button
    document.addEventListener('click', (e) => {
      if (e.target.closest('.wishlist-clear')) {
        this.clearWishlist();
        this.renderWishlist();
      }
    });
  }

  addProductToCart(variantId, button) {
    const originalText = button.textContent;
    button.textContent = 'Adding...';
    button.disabled = true;

    // Create form data for cart API
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);

    // Use theme's cart add URL if available
    const cartUrl = window.theme?.routes?.cart_add_url || '/cart/add';
    console.log('Using cart URL:', cartUrl);

    fetch(cartUrl, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/javascript',
      },
      body: formData
    })
    .then(response => response.json())
    .then(response => {
      console.log('Cart response:', response);
      
      if (response.status) {
        // Error occurred (same as theme)
        console.error('Cart error:', response);
      } else {
        // Success (same as theme)
        console.log('Product added to cart successfully');
        
        // Simple approach: just refresh the page
        console.log('Refreshing page after adding to cart');
        
        // Refresh the page
        window.location.reload();
        
        // Trigger cart update event (exactly like theme)
        document.dispatchEvent(new CustomEvent('theme:cart:add', {
          bubbles: true,
          detail: {
            selector: button,
          },
        }));
      }
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
    })
    .finally(() => {
      // Reset button state
      button.textContent = originalText;
      button.disabled = false;
    });
  }

  renderEmptyState(container) {
    const settings = window.wishlistSettings || {};
    const showSuggestedProducts = settings.showSuggestedProducts !== false; // Default to true
    const emptyTitle = settings.emptyTitle || 'YOUR WISHLIST IS EMPTY';
    const ctaText = settings.ctaText || 'SEE MORE PRODUCTS';
    const ctaLink = settings.ctaLink || '/collections/all';
    
    console.log('Rendering empty state with settings:', settings);
    console.log('showSuggestedProducts:', showSuggestedProducts);
    console.log('suggestedCollection:', settings.suggestedCollection);
    console.log('suggestedCollection type:', typeof settings.suggestedCollection);
    
    // Remove wishlist-no-padding class when wishlist is empty
    const wishlistContent = document.querySelector('.wishlist-content');
    if (wishlistContent) {
      wishlistContent.classList.remove('wishlist-no-padding');
    }
    
    if (showSuggestedProducts && settings.suggestedCollection) {
      console.log('Fetching suggested products...');
      // Fetch suggested products from collection
      this.fetchSuggestedProducts(container, settings, emptyTitle, ctaText, ctaLink);
    } else {
      console.log('Not showing suggested products. showSuggestedProducts:', showSuggestedProducts, 'suggestedCollection:', settings.suggestedCollection);
      // Show simple empty state
      container.innerHTML = `
        <div class="wishlist-empty">
          <h2 class="wishlist-empty__title">${emptyTitle}</h2>
          <div class="wishlist-suggestions">
            <div class="wishlist-suggestions__cta">
              <a href="${ctaLink}" class="wishlist-suggestions__link">${ctaText}</a>
            </div>
          </div>
        </div>
      `;
    }
  }

  async fetchMissingTags() {
    // Find items that don't have tags
    const itemsNeedingTags = this.wishlist.filter(item => !item.tags || item.tags.length === 0);
    
    if (itemsNeedingTags.length === 0) {
      return;
    }

    console.log('Fetching tags for', itemsNeedingTags.length, 'wishlist items');

    // Fetch product data for items missing tags
    const fetchPromises = itemsNeedingTags.map(async (item) => {
      if (!item.handle) return;
      
      try {
        const response = await fetch(`/products/${item.handle}.json`);
        if (response.ok) {
          const data = await response.json();
          if (data.product && data.product.tags) {
            // Parse tags - they come as comma-separated string from API
            const tags = typeof data.product.tags === 'string' 
              ? data.product.tags.split(',').map(t => t.trim()).filter(t => t)
              : data.product.tags;
            
            // Update the item in wishlist
            const index = this.wishlist.findIndex(i => i.id === item.id);
            if (index !== -1) {
              this.wishlist[index].tags = tags;
              console.log('Updated tags for', item.title, ':', tags);
            }
          }
        }
      } catch (error) {
        console.error('Error fetching tags for', item.handle, error);
      }
    });

    await Promise.all(fetchPromises);
    
    // Save updated wishlist with tags
    this.saveWishlist();
  }

  async fetchSuggestedProducts(container, settings, emptyTitle, ctaText, ctaLink) {
    try {
      const collectionHandle = settings.suggestedCollection;
      const productCount = settings.suggestedProductsCount || 4;
      
      console.log('Fetching suggested products from collection:', collectionHandle);
      console.log('Settings:', settings);
      console.log('Collection handle type:', typeof collectionHandle);
      console.log('Collection handle value:', collectionHandle);
      
      if (!collectionHandle) {
        console.error('No collection handle provided');
        throw new Error('No collection handle provided');
      }
      
      // Fetch collection products
      const response = await fetch(`/collections/${collectionHandle}/products.json?limit=${productCount}`);
      console.log('Fetch response status:', response.status);
      
      if (!response.ok) {
        console.error('Failed to fetch collection products:', response.status, response.statusText);
        throw new Error(`Failed to fetch collection: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (data.products && data.products.length > 0) {
        const productsHTML = data.products.map(product => {
          // Get the first available image from the product
          let image = '';
          if (product.images && product.images.length > 0) {
            image = product.images[0].src;
          } else if (product.featured_image) {
            image = product.featured_image.src || product.featured_image;
          } else if (product.variants && product.variants.length > 0 && product.variants[0].featured_image) {
            image = product.variants[0].featured_image.src;
          } else {
            image = 'https://biggles-amsterdam.myshopify.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_300x300.gif';
          }
          
          const price = product.price ? (product.price / 100).toFixed(2) : '0.00';
          const comparePrice = product.compare_at_price ? (product.compare_at_price / 100).toFixed(2) : null;
          
          // Fix product URL - Shopify API returns handle, not full URL
          const productUrl = product.handle ? `/products/${product.handle}` : '#';
          
          // Create price HTML similar to product-price snippet
          let priceHTML = '';
          if (comparePrice && comparePrice !== price) {
            priceHTML = `
              <span class="product-grid-item__price-new">€${price}</span>
              <s>€${comparePrice}</s>
            `;
          } else {
            priceHTML = `<span>€${price}</span>`;
          }
          
          return `
            <div class="product-grid-item grid__item one-quarter mobile--one-half" data-suggestion-item>
              <div class="product-grid-item__image">
                <div class="product__media__container" style="--aspect-ratio: 0.66650390625;">
                  <a class="product__media__holder" href="${productUrl}" aria-label="${product.title}">
                    <div class="product__media__image product__media__image--hover-none">
                      <figure class="lazy-image background-size-cover product__media product__media--featured-visible" data-product-image="" data-grid-image="">
                        <img 
                          src="${image}" 
                          alt="${product.title}"
                          width="1365" 
                          height="2047" 
                          loading="eager"
                          sizes="(min-width: 1440px) calc((100vw - 120px - 330px - 40px) / 3), (min-width: 1024px) calc((100vw - 120px - 270px - 40px) / 3), (min-width: 768px) calc((100vw - 40px - 240px - 40px) / 3), calc((100vw - 40px - 20px) / 2)"
                          srcset="
Liquid error (snippets/image-srcset line 28): quality can't be used with ext png 300w, Liquid error (snippets/image-srcset line 28): quality can't be used with ext png 400w, Liquid error (snippets/image-srcset line 28): quality can't be used with ext png 500w, Liquid error (snippets/image-srcset line 28): quality can't be used with ext png 600w, Liquid error (snippets/image-srcset line 28): quality can't be used with ext png 700w, Liquid error (snippets/image-srcset line 28): quality can't be used with ext png 800w, Liquid error (snippets/image-srcset line 28): quality can't be used with ext png 900w, Liquid error (snippets/image-srcset line 28): quality can't be used with ext png 1000w, Liquid error (snippets/image-srcset line 28): quality can't be used with ext png 1200w"
                        />
                      </figure>
                    </div>
                  </a>
                </div>
              </div>

              <div class="product-grid-item__info">
                <div class="product-grid-item__info-flex">
                  <div class="product-grid-item__info-left">
                    <a class="product-grid-item__title" href="${productUrl}" aria-label="${product.title}">
                      ${product.title}
                    </a>
                  </div>
                  <div class="product-grid-item__info-right">
                    <a class="product-grid-item__price price" href="${productUrl}">
                      ${priceHTML}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          `;
        }).join('');
        
        container.innerHTML = `
          <div class="wishlist-empty">
            <h2 class="wishlist-empty__title">${emptyTitle}</h2>
            <div class="wishlist-suggestions">
              <div class="wishlist-suggestions__grid">
                ${productsHTML}
              </div>
              <div class="wishlist-suggestions__cta">
                <a class="btn btn--text btn--small btn--black btn--advanced btn--view-all" href="${ctaLink}">
                  <hover-button></hover-button>${ctaText}
                </a>
              </div>
            </div>
          </div>
        `;
      } else {
        // Fallback to simple empty state if no products found
        container.innerHTML = `
          <div class="wishlist-empty">
            <h2 class="wishlist-empty__title">${emptyTitle}</h2>
            <div class="wishlist-suggestions">
              <div class="wishlist-suggestions__cta">
                <a href="${ctaLink}" class="wishlist-suggestions__link">${ctaText}</a>
              </div>
            </div>
          </div>
        `;
      }
    } catch (error) {
      console.error('Error fetching suggested products:', error);
      console.error('Error details:', error.message);
      // Fallback to simple empty state
      container.innerHTML = `
        <div class="wishlist-empty">
          <h2 class="wishlist-empty__title">${emptyTitle}</h2>
          <div class="wishlist-suggestions">
            <div class="wishlist-suggestions__cta">
              <a href="${ctaLink}" class="wishlist-suggestions__link">${ctaText}</a>
            </div>
          </div>
        </div>
      `;
    }
  }


  async renderWishlist() {
    const container = document.querySelector('[data-wishlist-items]');
    if (!container) {
      console.log('Wishlist container not found, skipping render');
      return;
    }

    console.log('Rendering wishlist with', this.wishlist.length, 'items');
    console.log('Current wishlist settings:', window.wishlistSettings);

    if (this.wishlist.length === 0) {
      this.renderEmptyState(container);
      return;
    }

    // Fetch missing tags for items that don't have them
    await this.fetchMissingTags();

    // Update padding class based on item count
    this.updateWishlistPadding();

    const itemsHTML = this.wishlist.map(item => {
      console.log('Rendering wishlist item:', item);
      console.log('Image URL for item:', item.image);
      
      // Create price HTML similar to product-price snippet
      let priceHTML = '';
      if (item.compare_at_price && item.compare_at_price !== item.price) {
        priceHTML = `
          <span class="product-grid-item__price-new">${item.price}</span>
          <s>${item.compare_at_price}</s>
        `;
      } else {
        priceHTML = `<span>${item.price}</span>`;
      }
      
      return `
        <div class="product-grid-item grid__item one-quarter mobile--one-half" data-wishlist-item="${item.id}">
          <div class="product-grid-item__image">
            <div class="product__media__container" style="--aspect-ratio: 0.66650390625;">
              <a class="product__media__holder" href="${item.url}" aria-label="${item.title}">
                <div class="product__media__image product__media__image--hover-none">
                  <figure class="lazy-image background-size-cover product__media product__media--featured-visible" data-product-image="" data-grid-image="">
                    <img 
                      src="${item.image}" 
                      alt="${item.title}" 
                      width="600" 
                      height="900" 
                      loading="eager" 
                      sizes="(min-width: 1440px) calc((100vw - 120px - 330px - 40px) / 3), (min-width: 1024px) calc((100vw - 120px - 270px - 40px) / 3), (min-width: 768px) calc((100vw - 40px - 240px - 40px) / 3), calc((100vw - 40px - 20px) / 2)" 
                    />
                  </figure>
                </div>
              </a>
            </div>
            
            <!-- Wishlist Button -->
            <div class="product-grid-item__wishlist wishlist-container--active">
              <button 
                class="wishlist-button wishlist-button--grid wishlist-button--active"
                data-wishlist-button="" 
                data-product-id="${item.id}"
                aria-label="Remove from wishlist">
                <span class="wishlist-button__icon">
                  <span class="wishlist-button__icon--filled">
                    <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10 18L9.64706 17.697C2.05882 11.3333 0 9.09091 0 5.45455C0 2.42424 2.35294 0 5.29412 0C7.70588 0 9.05882 1.39394 10 2.48485C10.9412 1.39394 12.2941 0 14.7059 0C17.6471 0 20 2.42424 20 5.45455C20 9.09091 17.9412 11.3333 10.3529 17.697L10 18Z" fill="currentColor"></path>
                    </svg>
                  </span>
                </span>
              </button>
            </div>
          </div>

          <div class="product-grid-item__info">
            <div class="product-grid-item__info-flex">
              <div class="product-grid-item__info-left">
                <a class="product-grid-item__title" href="${item.url}" aria-label="${item.title}">
                  ${item.title}
                </a>
              </div>
              <div class="product-grid-item__info-right">
                <a class="product-grid-item__price price" href="${item.url}">
                  ${priceHTML}
                </a>
              </div>
            </div>

            <div class="product-grid-item__actions">
              <button 
                class="btn btn--primary btn--small wishlist-add-to-cart${item.tags && item.tags.includes('store-only') ? ' hidden' : ''}"
                data-product-id="${item.id}"
                data-variant-id="${item.variant_id}"
                data-product-url="${item.url}"
                ${!item.available ? 'disabled' : ''}
              >
                ${item.available ? 'ADD TO CART' : 'OUT OF STOCK'}
              </button>
              ${item.tags && item.tags.includes('store-only') ? `
                <div class="store-only">
                  Only in store or WhatsApp
                </div>
              ` : ''}
            </div>
          </div>
        </div>
      `;
    }).join('');

    container.innerHTML = itemsHTML;
  }

  // Method to re-render when settings become available
  reRenderWithSettings() {
    console.log('Re-rendering wishlist with updated settings');
    this.renderWishlist();
  }
}

// Initialize wishlist when DOM is loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    console.log('DOM loaded, initializing wishlist...');
    window.wishlist = new Wishlist();
    
    // Update buttons after a short delay to ensure all elements are rendered
    setTimeout(() => {
      if (window.wishlist) {
        window.wishlist.updateWishlistButtons();
      }
    }, 200);
  });
} else {
  console.log('DOM already loaded, initializing wishlist...');
  window.wishlist = new Wishlist();
  
  // Update buttons after a short delay to ensure all elements are rendered
  setTimeout(() => {
    if (window.wishlist) {
      window.wishlist.updateWishlistButtons();
    }
  }, 200);
}

// Initialize wishlist on page load
document.addEventListener('DOMContentLoaded', () => {
  console.log('Initializing wishlist...');
  if (!window.wishlist) {
    window.wishlist = new Wishlist();
  }
  
  // Update buttons after a short delay to ensure all elements are rendered
  setTimeout(() => {
    if (window.wishlist) {
      window.wishlist.updateWishlistButtons();
    }
  }, 200);
  
  // Render wishlist if we're on the wishlist page
  if (window.location.pathname === '/pages/wishlist') {
    window.wishlist.renderWishlist();
  }
});
